var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { get } from '../../utils/themeGet';
const EyeClosedIcon = (_a) => {
    var { size = 'medium', color = 'inherit' } = _a, rest = __rest(_a, ["size", "color"]);
    const props = Object.assign(Object.assign({}, rest), { color });
    const sizePx = Number.isFinite(size)
        ? size
        : get(`iconSizes.${size}`)(props) || get('iconSizes.medium')(props);
    return (React.createElement("svg", Object.assign({}, props, { width: sizePx, height: sizePx, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M12 20c-5.035 0-9.28-3.383-10.586-8h2.098a9.005 9.005 0 0016.976 0h2.098c-1.306 4.617-5.55 8-10.586 8z", fill: "currentColor" }),
        React.createElement("path", { d: "M2.361 14.305c.163.295.339.581.527.859L.926 16.729l-.624-.782 2.06-1.642z", fill: "currentColor" }),
        React.createElement("path", { d: "M.926 16.73l1.962-1.565c.188.276.388.544.599.802L1.55 17.51l-.624-.782zM4.896 20.18l.982-2.04c.278.187.564.36.859.522l-.94 1.952-.9-.434zM5.797 20.614l.94-1.952c.292.159.592.306.9.439l-.939 1.947-.9-.434z", fill: "currentColor" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.872 22v-2.057c.329.034.662.053 1 .056V22h-1zm1 0v-2a11.026 11.026 0 001-.034V22h-1zM17.045 21.048l-.895-1.858c.31-.126.613-.266.908-.42l.888 1.844-.9.434zm.901-.434l-.888-1.843c.298-.155.588-.323.87-.503l.919 1.912-.9.434z", fill: "currentColor" }),
        React.createElement("path", { d: "M22.194 17.511l-1.783-1.421c.215-.255.418-.52.61-.793l1.796 1.432-.623.782zM23.44 15.947l-.623.782-1.796-1.433c.192-.274.372-.558.538-.85l1.882 1.501z", fill: "currentColor" })));
};
export default EyeClosedIcon;
